import React from "react";
import Rollbar from '../utils/RollbarTracking'
import axios from 'axios'
import moment from 'moment'
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

export class OrdersView extends React.Component {

  state = {
      myOrderData: {},
      orderLineItems: [],
      paymentDueDate: null,
      loading: false
  }

  componentWillMount() {
    this.fetchOrderData();
    this.fetchOrderLineItems()
  }

  deleteOrder = async () => {
    axios.delete('/orders/' + this.props.match.params.id)
        .then(data => {
          console.log(data);
          this.props.history.push("/orders");
        })
        .catch ( err => {
          console.log(err)
          Rollbar.error(err)
          toast.error('Failed to delete order')
        })
  }

  sendInvoice = async () => {
    this.setState({loading: true})
    toast.warning('Generatoring Invoice...please wait')
    let requestParams = {
      'order_id': this.props.match.params.id,
      'email': this.state.myOrderData.email
    }
    axios.post('/email/invoice', requestParams)
        .then(data => {
          this.setState({loading: false})
          console.log(data)
          toast.dismiss();
          this.fetchOrderData()
        })
        .catch (err => {
          this.setState({loading: false})
          console.log(err)
          Rollbar.error(err)
          toast.error('Failed to generate invoice')
        })
  }

  fetchOrderData = async () => {
    axios.get('/orders/' + this.props.match.params.id)
        .then(data => {
          console.log(data);
          this.setState({
            myOrderData: data[0],
          });
        })
        .catch (err => {
          console.log(err);
          Rollbar.error(err)
          toast.error('Failed to fetch order record')
        })
  }

  fetchOrderLineItems = async () => {
    axios.get('/orders/' + this.props.match.params.id + '/lineitems')
        .then(data => {
          console.log(data);
          this.setState({
            orderLineItems: data,
          });
        })
        .catch (err => {
          console.log(err);
          Rollbar.error(err)
          toast.error('Failed to fetch order line items')
        })
  }

  updateOrderStatus = async (newStatus) => {
    let requestParams = {
      'orderID': this.props.match.params.id,
      'status': newStatus
    }
    axios.post('/orders/update/status', requestParams)
        .then(data => {
          console.log(data);
          this.fetchOrderData();
        })
        .catch (err => {
          console.log(err)
          Rollbar.error(err)
          toast.error('Failed to update order status')
        })
  }

  downloadInvoice = async () => {
    axios.get('/orders/' + this.props.match.params.id + '/invoiceurl')
        .then(data => {
          console.log(data);
          window.open(data.url)
        })
        .catch (err => {
          console.log(err);
          Rollbar.error(err)
          toast.error('Failed to download invoice')
        })
  }

  statusBadge(status) {
    if (status == 'Pending') {
      return <span className="badge badge-warning">Pending</span>
    } else if (status == 'Accepted') {
      return <span className="badge badge-info">Accepted</span>
    } else if (status == 'Invoiced') {
      return <span className="badge badge-success">Invoiced</span>
    } else if (status == 'Paid') {
      return <span className="badge badge-secondary">Paid</span>
    }
  }

    render() {
        return (
          <div>
            {this.state.myOrderData ? 
            <div>
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1 mb-3 border-bottom">
                <h1 className="h3">View Order</h1>
              </div>
              <div className="mar-bot-lg">
                {this.state.myOrderData.status === "Pending" || this.state.myOrderData.status === "Accepted" ? <Link to={'/orders/edit/' + this.props.match.params.id}><button type="button" className="btn btn-warning btn-sm mar-bot mar-right">Edit</button></Link> : null}
                {this.state.myOrderData.status === "Pending" || !this.state.myOrderData.status ? <button type="button"  onClick={() => this.updateOrderStatus("Accepted")} className="btn btn-success btn-sm mar-bot mar-right">Accept</button> : null }
                {this.state.myOrderData.status === "Accepted" ? <button type="button"  onClick={() => this.sendInvoice()} className="btn btn-primary btn-sm mar-bot mar-right" disabled={this.state.loading}>Send Invoice</button>  : null}
                {this.state.myOrderData.status === "Invoiced" && !this.props.settings.integration.type ? <button type="button"  onClick={() => this.updateOrderStatus("Paid")} className="btn btn-secondary btn-sm mar-bot mar-right">Mark as Paid</button> : null }
                {this.state.myOrderData.status === "Pending" || this.state.myOrderData.status === "Accepted" ? <button type="button"  onClick={() => this.deleteOrder()} className="btn btn-danger btn-sm mar-bot mar-right">Delete Order</button> : null}
                {!this.props.settings.integration.type && (this.state.myOrderData.status === "Invoiced" || this.state.myOrderData.status === "Paid")  ? <button type="button"  onClick={() => this.downloadInvoice()} className="btn btn-info btn-sm mar-bot mar-right">Download Invoice</button> : null}
                {this.state.myOrderData.status === "Invoiced" && !this.props.settings.integration.type ? <button type="button"  onClick={() => this.updateOrderStatus("Accepted")} className="btn btn-dark btn-sm mar-bot mar-right">Revert to Accepted</button> : null }
                {this.state.myOrderData.status === "Paid" && !this.props.settings.integration.type ? <button type="button"  onClick={() => this.updateOrderStatus("Invoiced")} className="btn btn-dark btn-sm mar-bot mar-right">Revert to Invoiced</button> : null }
                <div className="card">
                  <div className="card-header">
                    Order No.
                    <strong>{this.state.myOrderData.orderID}</strong>
                    <span className="float-right"> <strong>Status: </strong>{this.statusBadge(this.state.myOrderData.status)}</span>
                  </div>
                  <div className="card-body">
                    <div className="row mb-4">
                      <div className="col-sm-7">
                        <h6 className="mb-3">Customer:</h6>
                        <div>
                          <strong>{this.state.myOrderData.company}</strong>
                        </div>
                        <div>{this.state.myOrderData.name}</div>
                        <div>{this.state.myOrderData.address}</div>
                        <div>Email: {this.state.myOrderData.email}</div>
                        <div>Phone: {this.state.myOrderData.phone}</div>
                      </div>
                      <div className="col-sm-5">
                        <h6 className="mb-3">Order Details:</h6>
                        <div>
                          <strong>{this.props.user.name}</strong>
                        </div>
                        <div>Order No: {this.props.match.params.id}</div>
                        <div>Delivery Day: {this.state.myOrderData.deliveryDay}</div>
                        <div>Payment Due by: {this.state.myOrderData.paymentDue}</div>
                        <div>Date Placed: {this.state.myOrderData.date}</div>
                      </div>
                    </div>
                    <div className="table-responsive-sm">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th className="center">#</th>
                            <th>Item</th>
                            <th className="right">Unit Cost</th>
                            <th className="center">Qty</th>
                            <th className="right">Total</th>
                          </tr>
                        </thead>
                          <tbody>
                            {this.state.orderLineItems.map((data, i) =>
                              <tr key={i}>
                                <td className="center">{i + 1}</td>
                                <td className="left strong">{data.name}</td>
                                <td className="right">{data.unitPrice}</td>
                                <td className="center">{data.quantity}</td>
                                <td className="right">{(data.unitPrice*data.quantity).toFixed(2)}</td>
                              </tr>
                            )}
                          </tbody>
                      </table>
                    </div>
                    <div className="row">
                      <div className="col-lg-4 col-sm-5">
                        <h6>Comment:</h6>
                        <p>{this.state.myOrderData.comment}</p>
                      </div>
                      <div className="col-lg-4 col-sm-5 ml-auto">
                        <table className="table table-clear">
                          <tbody>
                            <tr>
                              <td className="left">
                                <strong>Adjustment</strong>
                              </td>
                              <td className="right">${this.state.myOrderData.adjustment}</td>
                            </tr>
                            {/* <tr>
                              <td className="left">
                                <strong>GST (10%)</strong>
                              </td>
                              <td className="right">${(this.state.myOrderData.total*0.1).toFixed(2)}</td>
                            </tr> */}
                            <tr>
                              <td className="left">
                                <strong>Total</strong>
                              </td>
                              <td className="right">
                                <strong>${this.state.myOrderData.total}</strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> : null}
          </div>
        );
    }
}
